import { Link } from 'react-router-dom'

const Logo = () => {
    return (
        <div>
            <Link to="/" 
                className="f1-50 gold0 b"
            >
                Bedidi
            </Link>
        </div>
    )
}

export default Logo